import { axios } from "utilities/axios";
import { AxiosError } from "axios";
import { IInteractionVariable, IInteractionVariablesValues, Route } from "@edgetier/watchtower-types";
import { useQuery, UseQueryOptions } from "react-query";

/**
 * Request the interaction variables values from the backend.
 * @param url The URL of the interaction.
 * @returns The interaction details.
 */
const getInteractionVariablesValues = async (url: string) => {
    const { data } = await axios.get<IInteractionVariablesValues>(url);
    return data.items;
};

/**
 * A query for requesting an interactions variables values.
 * @param interactionId The ID of the interaction being requested.
 * @returns
 */
export const useInteractionVariablesValues = <T = IInteractionVariable[]>(
    interactionId: string,
    options: Omit<UseQueryOptions<IInteractionVariable[], AxiosError, T>, "queryKey" | "queryFn"> = {}
) => {
    const url = Route.InteractionVariablesValues.replace(":interactionId", interactionId);
    return useQuery<IInteractionVariable[], AxiosError, T>(
        [url, interactionId],
        () => getInteractionVariablesValues(url),
        options
    );
};
